module.exports = __webpack_public_path__ + "img/empty.fd8e5136.svg";